/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DuplicateTournamentBody
 */
export interface DuplicateTournamentBody {
    /**
     * New tournament name (defaults to "Copy of [original name]")
     * @type {string}
     * @memberof DuplicateTournamentBody
     */
    name?: string;
    /**
     * New start time (epoch ms)
     * @type {number}
     * @memberof DuplicateTournamentBody
     */
    startTime?: number;
    /**
     * New registration open time (epoch ms)
     * @type {number}
     * @memberof DuplicateTournamentBody
     */
    registrationOpens?: number;
    /**
     * New registration close time (epoch ms)
     * @type {number}
     * @memberof DuplicateTournamentBody
     */
    registrationCloses?: number;
}

/**
 * Check if a given object implements the DuplicateTournamentBody interface.
 */
export function instanceOfDuplicateTournamentBody(value: object): value is DuplicateTournamentBody {
    return true;
}

export function DuplicateTournamentBodyFromJSON(json: any): DuplicateTournamentBody {
    return DuplicateTournamentBodyFromJSONTyped(json, false);
}

export function DuplicateTournamentBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): DuplicateTournamentBody {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'startTime': json['startTime'] == null ? undefined : json['startTime'],
        'registrationOpens': json['registrationOpens'] == null ? undefined : json['registrationOpens'],
        'registrationCloses': json['registrationCloses'] == null ? undefined : json['registrationCloses'],
    };
}

export function DuplicateTournamentBodyToJSON(json: any): DuplicateTournamentBody {
    return DuplicateTournamentBodyToJSONTyped(json, false);
}

export function DuplicateTournamentBodyToJSONTyped(value?: DuplicateTournamentBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'startTime': value['startTime'],
        'registrationOpens': value['registrationOpens'],
        'registrationCloses': value['registrationCloses'],
    };
}

